import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash-es';
/* Constants */
import {
  ENTRYPOINT_ICONS_WITH_TEXT,
  CAPITAL_ONE_LOGO_SRC,
  CAPITAL_ONE_ENTRY_POINT_CONTENT,
} from 'site-modules/shared/constants/financing/financing-constants';
/* Utils */
import { getStaticImageUrl } from 'client/utils/image-helpers';
/* Components */
import { Link } from 'site-modules/shared/components/link/link';
import { IconWithText } from './icon-with-text';

export function CapitalOneEntryPointPartner({
  vinData = {},
  isCapOne = false,
  isCapOneIneligible = false,
  shop4713Recipe = 'ctrl',
}) {
  const isShop4713Chal = shop4713Recipe === 'chal';

  const url = `/financing/${isCapOneIneligible && !isShop4713Chal ? 'prequalify-and-shop' : vinData.vin}/${isShop4713Chal ? 'request' : 'basics'}`;
  const defaultCreativeId = `${get(vinData, 'type', '').toLowerCase()}-summary_financing-${
    isCapOne ? 'matched' : 'unmatched'
  }-vin${isCapOneIneligible ? '-ineligible' : ''}`;

  const creativeId = isShop4713Chal ? 'used-summary_financing-lead' : defaultCreativeId;

  return (
    <div
      className="capital-one-container capital-one-container-box-shadow rounded bg-white"
      style={{
        textAlign: 'left',
        marginTop: '24px',
        padding: '12px 16px 16px',
      }}
      data-tracking-parent={creativeId}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <img width={103} height={37} src={getStaticImageUrl(CAPITAL_ONE_LOGO_SRC)} alt="Capital One" />

        <h2
          className="text-cool-gray-30"
          style={{
            fontWeight: 'bold',
            marginTop: '16px',
            marginBottom: '16px',
            fontSize: '20px',
          }}
        >
          {CAPITAL_ONE_ENTRY_POINT_CONTENT.TITLE}
        </h2>
        <div
          style={{
            display: 'flex',
            width: '100%',
            justifyContent: 'space-around',
            textAlign: 'center',
            marginTop: '8px',
            marginBottom: '8px',
          }}
        >
          {ENTRYPOINT_ICONS_WITH_TEXT.map((info, index) => (
            <IconWithText key={`entry-point-icon_${index + 1}`} info={info} isCapOneIneligible={isCapOneIneligible} />
          ))}
        </div>
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <Link
            to={url}
            className="btn btn-sm btn-success"
            style={{
              fontWeight: 'medium',
              fontSize: '16px',
              textTransform: 'none',
              marginTop: '16px',
            }}
            data-tracking-id={isShop4713Chal ? 'financing_cta_lead_form' : 'financing_cta'}
            data-tracking-value={CAPITAL_ONE_ENTRY_POINT_CONTENT.CTA_TEXT}
          >
            <span>{CAPITAL_ONE_ENTRY_POINT_CONTENT.CTA_TEXT}</span>
          </Link>
        </div>
      </div>
    </div>
  );
}

CapitalOneEntryPointPartner.propTypes = {
  vinData: PropTypes.shape({}),
  content: PropTypes.shape({}),
  isCapOne: PropTypes.bool,
  isCapOneIneligible: PropTypes.bool,
  shop4713Recipe: PropTypes.string,
};
